import { render } from "./JobManagement.vue?vue&type=template&id=5afc4bfa&scoped=true"
import script from "./JobManagement.vue?vue&type=script&lang=js"
export * from "./JobManagement.vue?vue&type=script&lang=js"

import "./JobManagement.vue?vue&type=style&index=0&id=5afc4bfa&scoped=true&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5afc4bfa"]])

export default __exports__